<template>
  <div class="supply-hall" :style="{ width: '1400px', margin: '0 auto' }">
    <div class="supply-hall-banner">
      <img :src="imageUrl" alt="供应大厅" />
      <span class="domTitle">供应大厅</span>
    </div>
    <!-- 筛选区域：左右分区布局 -->
    <div class="bigScreen">
      <el-card class="box-card">
        <div class="filter-bar">
          <!-- 左侧：筛选控件组 -->
          <div class="filter-left">
            <el-row>
              <el-col :span="24">
                <div class="filter-item">
                  <div class="filter-label">
                    <span>区域：</span>
                  </div>
                  <el-cascader
                    v-model="filterParams.adcode"
                    :options="locationOptions"
                    clearable
                    :props="{
                      label: 'name',
                      value: 'adcode',
                      checkStrictly: true,
                    }"
                    @change="getSupplyList"
                  />
                </div>
              </el-col>
              <el-col :span="24">
                <div class="filter-item">
                  <div class="filter-label">
                    <span>类型：</span>
                  </div>
                  <div class="filter-tags">
                    <el-tag
                      @click="handleTypeChange({ name: '全部', value: '' })"
                      class="type-tag"
                      :class="filterParams.type === '' ? 'choseTag' : ''"
                      effect="dark"
                    >
                      全部
                    </el-tag>
                    <el-tag
                      v-for="(item, idx) in typeList"
                      :key="idx"
                      @click="handleTypeChange(item)"
                      class="type-tag"
                      :class="
                        filterParams.type === item.value ? 'choseTag' : ''
                      "
                      effect="dark"
                    >
                      {{ item.name }}
                    </el-tag>
                  </div>
                </div>
              </el-col>
              <!--              <el-col :span="24">-->
              <!--                <div class="filter-item" v-if="false">-->
              <!--                  <div class="filter-label">-->
              <!--                    <span>数量：</span>-->
              <!--                  </div>-->
              <!--                  <div class="filter-tags">-->
              <!--                    <el-tag-->
              <!--                        v-for="(item, idx) in countList"-->
              <!--                        effect="dark"-->
              <!--                        :key="idx"-->
              <!--                        :class="filterParams.count === item ? 'choseTag' : ''"-->
              <!--                        @click="handleCountChange(item)"-->
              <!--                        class="count-tag"-->
              <!--                    >-->
              <!--                      {{ item }}-->
              <!--                    </el-tag>-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--              </el-col>-->
            </el-row>
          </div>
          <!-- 右侧：发布需求按钮 -->
          <div class="filter-right">
            <el-button
              class="filter-right-btn-secondary"
              size="medium"
              @click="handleDownloadTemplate"
              >下载模板
            </el-button>
            <el-button
              class="filter-right-btn-secondary"
              size="medium"
              @click="handleImport"
              >导入
            </el-button>
            <el-button
              class="filter-right-btn"
              type="success"
              @click="openPublishDialog"
              >发布供应
            </el-button>
          </div>
        </div>
      </el-card>
    </div>
    <div class="smallScreen">
      <el-card class="box-card">
        <div class="filter-bar">
          <!-- 左侧：筛选控件组 -->
          <div class="filter-left">
            <el-row>
              <el-col :span="24">
                <div class="filter-item">
                  <div class="filter-label">
                    <span>区域：</span>
                  </div>
                  <el-cascader
                    v-model="filterParams.adcode"
                    :options="locationOptions"
                    clearable
                    :props="{
                      label: 'name',
                      value: 'adcode',
                      checkStrictly: true,
                    }"
                    @change="getSupplyList"
                  />
                </div>
              </el-col>
              <el-col :span="24">
                <div class="filter-item">
                  <div class="filter-label">
                    <span>类型：</span>
                  </div>
                  <div class="filter-tags">
                    <el-tag
                      @click="handleTypeChange({ name: '全部', value: '' })"
                      class="type-tag"
                      :class="filterParams.type === '' ? 'choseTag' : ''"
                      effect="dark"
                    >
                      全部
                    </el-tag>
                    <el-tag
                      v-for="(item, idx) in typeList"
                      :key="idx"
                      @click="handleTypeChange(item)"
                      class="type-tag"
                      :class="
                        filterParams.type === item.value ? 'choseTag' : ''
                      "
                      effect="dark"
                    >
                      {{ item.name }}
                    </el-tag>
                  </div>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="filter-item" v-if="false">
                  <div class="filter-label">
                    <span>数量：</span>
                  </div>
                  <div class="filter-tags">
                    <el-tag
                      v-for="(item, idx) in countList"
                      effect="dark"
                      :key="idx"
                      :class="filterParams.count === item ? 'choseTag' : ''"
                      @click="handleCountChange(item)"
                      class="count-tag"
                    >
                      {{ item }}
                    </el-tag>
                  </div>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="filter-right">
                  <el-button
                    class="filter-right-btn-secondary"
                    size="medium"
                    @click="handleDownloadTemplate"
                    >下载模板
                  </el-button>
                  <el-button
                    class="filter-right-btn-secondary"
                    size="medium"
                    @click="handleImport"
                    >导入
                  </el-button>
                  <el-button
                    class="filter-right-btn"
                    type="success"
                    @click="openPublishDialog"
                    >发布供应
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </div>
          <!-- 右侧：发布需求按钮 -->
        </div>
      </el-card>
    </div>
    <!-- 排序区域 -->
    <div v-if="false" class="sort-bar">
      <el-button
        type="text"
        icon="el-icon-arrow-up"
        :class="{ active: filterParams.sort === 'distance' }"
        @click="handleSortChange('distance')"
        >按距离排序
      </el-button>
      <el-button
        type="text"
        icon="el-icon-arrow-down"
        :class="{ active: filterParams.sort === 'time' }"
        @click="handleSortChange('time')"
        >按时间排序
      </el-button>
    </div>

    <!-- 卡片列表 -->
    <div class="card-list" v-if="supplyList.length">
      <div
        v-for="(item, idx) in supplyList"
        :key="item.id"
        class="supply-card"
        :class="{ 'recommended-card': item.recommend }"
        @click="openDetailDialog(item)"
      >
        <div v-if="item.recommend" class="recommend-badge">
          <i class="el-icon-star-on"></i>
          <span>智能推荐</span>
        </div>
        <el-row>
          <el-col :span="10">
            <img :src="BasrUrl + item.imgurl" class="card-img" />
          </el-col>
          <el-col :span="14">
            <div class="card-info">
              <div class="info-row">
                <h3 class="card-title">
                  {{ item.title }}
                  <el-tag style="margin-left: 10px" size="medium">
                    {{ getOrderRequirement(typeList, item.type) }}
                  </el-tag>
                </h3>
              </div>
              <div class="info-row info-grep">
                <p class="p">
                  挂单量：<span class="card-info"
                    >{{ item.amount }} {{ item.unit }}</span
                  >
                </p>
                <p class="p">
                  <span>业务类型：</span>
                  <span class="card-info">
                    {{ getOrderRequirement(typeList203, item.enterprise) }}
                  </span>
                </p>
              </div>
              <div class="info-row">
                <p class="p">
                  <i class="el-icon-location-information">&nbsp;</i
                  >{{ item.address }}
                </p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="empty-state" v-else>
      <el-empty description="暂无相关求购需求"></el-empty>
    </div>

    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      background
      :current-page="filterParams.pageNum"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="filterParams.pageSize"
      layout="prev, pager, next, jumper, ->, total, slot"
      :total="totalCount"
      class="pagination"
    ></el-pagination>

    <!-- 详情弹窗 -->
    <el-dialog
      title="供应详情"
      :visible.sync="detailDialogVisible"
      :width="dialogWidth"
      lock-scroll
    >
      <div class="detail-content" v-if="currentDetail.id">
        <el-image
          class="detail-img"
          :src="BasrUrl + currentDetail.imgurl"
          :preview-src-list="[BasrUrl + currentDetail.imgurl]"
        >
        </el-image>
        <div class="detail-info">
          <h3 class="detail-info-title">
            {{ currentDetail.title }}
            <el-tag size="medium"
              >{{ getOrderRequirement(typeList, currentDetail.type) }}
            </el-tag>
          </h3>
          <div class="detail-item">
            <span class="detail-label">挂单量：</span>
            <span class="detail-value"
              >{{ currentDetail.amount }}{{ currentDetail.unit }}</span
            >
          </div>
          <div class="detail-item">
            <span class="detail-label">业务类型：</span>
            <span class="detail-value">{{
              getOrderRequirement(typeList203, currentDetail.enterprise)
            }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">联系人：</span>
            <span class="detail-value">{{ currentDetail.linkman }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">联系方式：</span>
            <span class="detail-value">{{ currentDetail.phonenumber }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">地址：</span>
            <span class="detail-value"
              >{{
                getRegionNameByAdcode(locationOptions, currentDetail.adcode)
              }}
              {{ currentDetail.address }}</span
            >
          </div>
          <div class="detail-item">
            <span class="detail-label">说明：</span>
            <span class="detail-value">{{
              currentDetail.description || '暂无'
            }}</span>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 发布弹窗 -->
    <el-dialog
      title="发布供应"
      :visible.sync="publishDialogVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :width="dialogWidth"
      lock-scroll
    >
      <el-form
        :model="publishForm"
        :rules="publishRules"
        ref="publishFormRef"
        :label-width="labelWidth"
        class="publish-form"
      >
        <el-form-item label="标题" prop="title">
          <el-input v-model="publishForm.title" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select
            v-model="publishForm.type"
            style="width: 100%"
            placeholder="请选择"
            :disabled="publishLoading"
          >
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型图片" prop="imgurl">
          <image-upload @upload-success="handleImageSuccess" />
        </el-form-item>
        <el-form-item label="挂单量" prop="amount">
          <el-input
            v-model="publishForm.amount"
            placeholder="请输入"
            style="width: 75%"
            :disabled="publishLoading"
          ></el-input>
          <el-select
            v-model="publishForm.unit"
            placeholder="请选择单位"
            style="width: 20%; margin-left: 10px"
            :disabled="publishLoading"
          >
            <el-option label="斤" value="斤"></el-option>
            <el-option label="吨" value="吨"></el-option>
            <el-option label="台/套" value="台/套"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="!requirePath"
          label="接单要求"
          prop="orderRequirement"
        >
          <el-select
            v-model="publishForm.orderRequirement"
            style="width: 100%"
            placeholder="请选择"
            :disabled="publishLoading"
          >
            <el-option
              v-for="item in requireForm"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-else label="业务类型" prop="enterprise">
          <el-select
            v-model="publishForm.enterprise"
            style="width: 100%"
            placeholder="请选择"
            :disabled="publishLoading"
          >
            <el-option
              v-for="item in typeList203"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系人" prop="linkman">
          <el-input
            v-model="publishForm.linkman"
            placeholder="请输入"
            :disabled="publishLoading"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="phonenumber">
          <el-input
            v-model="publishForm.phonenumber"
            placeholder="请输入"
            :disabled="publishLoading"
          ></el-input>
        </el-form-item>
        <el-form-item label="区域" prop="adcode">
          <el-cascader
            v-model="publishForm.adcode"
            style="width: 100%"
            :options="locationOptions"
            clearable
            :props="{ label: 'name', value: 'adcode', checkStrictly: true }"
            @change="getSupplyList"
          />
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input
            v-model="publishForm.address"
            placeholder="请输入省-市-区详细地址"
            :disabled="publishLoading"
          ></el-input>
        </el-form-item>
        <el-form-item label="经纬度" prop="location">
          <el-input
            v-model="publishForm.location"
            style="width: 95%"
            placeholder="输入示例：130.31,30.212"
            :disabled="publishLoading"
          ></el-input>
          <el-tooltip placement="top">
            <template #content>
              <div>
                提示：经纬度查询可访问网址：
                <a
                  style="color: #3a8ee6"
                  href="https://lbs.amap.com/tools/picker"
                  target="_blank"
                  >https://lbs.amap.com/tools/picker</a
                >
              </div>
            </template>
            <i
              class="el-icon-question"
              style="margin-left: 10px; color: #409eff"
            />
          </el-tooltip>
        </el-form-item>
        <el-form-item label="说明" prop="description">
          <el-input
            v-model="publishForm.description"
            placeholder="请输入补充说明"
            type="textarea"
            :disabled="publishLoading"
          ></el-input>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button @click="resetPublishForm" :disabled="publishLoading"
          >取消
        </el-button>
        <el-button type="success" @click="submitPublish">提交</el-button>
      </template>
    </el-dialog>

    <!-- 隐藏的文件上传输入框 -->
    <el-dialog
      title="导入结果"
      :visible.sync="importResultVisible"
      :width="dialogWidth"
      lock-scroll
    >
      <div class="import-result-dialog">
        <div class="import-result-summary">
          <div class="summary-item">
            <span class="summary-label">总条数</span>
            <span class="summary-value">{{ importResult.totalCount }}</span>
          </div>
          <div class="summary-item success">
            <span class="summary-label">成功</span>
            <span class="summary-value">{{ importResult.successCount }}</span>
          </div>
          <div class="summary-item fail">
            <span class="summary-label">失败</span>
            <span class="summary-value">{{ importResult.failCount }}</span>
          </div>
        </div>
        <div class="import-result-message">{{ importResult.message }}</div>
        <div v-if="importResult.errorDetails.length" class="import-result-details">
          <div
            v-for="(item, index) in importResult.errorDetails"
            :key="index"
            class="detail-card"
          >
            <div class="detail-row">
              <span class="detail-label">失败行号</span>
              <span class="detail-value">第 {{ item.rowNum }} 行</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">失败原因</span>
              <span class="detail-value fail-text">{{ item.reason }}</span>
            </div>
            <div class="detail-row detail-row-column">
              <span class="detail-label">原始数据</span>
              <pre class="detail-data">{{ item.data }}</pre>
            </div>
          </div>
        </div>
      </div>
      <template slot="footer">
        <el-button type="primary" @click="importResultVisible = false">
          我知道了
        </el-button>
      </template>
    </el-dialog>

    <input
      ref="fileInput"
      type="file"
      accept=".xlsx, .xls"
      style="display: none"
      @change="handleImportFileChange"
    />
  </div>
</template>

<script>
// 本地生成模拟数据的工具函数
import { getAreaTreeData } from '@/API/news/news';
import imageUpload from '@/components/ImageUpload/ImageUpload.vue';
import {
  createPublish,
  getPublish,
  uploadTemplate,
} from '@/API/supplyDemand/supplyDemand';
import { getCategories } from '@/API/echarts/echarts';
import axios from 'axios';

export default {
  name: 'supplyHall',
  components: {
    imageUpload,
  },
  data() {
    return {
      imageUrl: require('@/assets/recycling/news/SupplyAndDemand.png'),
      locationOptions: [],
      loading: false,
      publishLoading: false,
      filterParams: {
        adcode: '',
        type: '',
        status: 0, // status 0：为审核通过，4：为待审核，5：为审核未通过状态
        // count: '<100斤',
        publishType: 1, // 1：为发布供应数据类型，2：为发布求购数据类型
        pageNum: 1,
        pageSize: 10,
      },
      supplyList: [],
      totalCount: 0,
      requirePath: this.$route.path === '/Home/supplyDemand/supplyHall',
      detailDialogVisible: false,
      publishDialogVisible: false,
      importResultVisible: false,
      currentDetail: {},
      importResult: {
        totalCount: 0,
        successCount: 0,
        failCount: 0,
        message: '',
        errorDetails: [],
      },
      requireForm: [
        { label: '快速接单（24小时内）', value: 'fast' },
        { label: '标准接单（3天内）', value: 'standard' },
        { label: '专业资质认证', value: 'certified' },
        { label: '上门服务', value: 'door_service' },
        { label: '量大优先', value: 'large_quantity' },
        { label: '价格最优', value: 'best_price' },
        { label: '长期合作', value: 'long_term' },
        { label: '环保资质齐全', value: 'environmental' },
      ],
      publishForm: {
        title: '', // 发布信息标题
        type: '', // 信息类型
        imgurl: '', // 图片URL地址
        amount: '', // 数量
        unit: '吨', // 单位，默认为吨
        orderRequirement: '', // 接单要求
        linkman: '', // 联系人姓名
        phonenumber: '', // 联系电话
        publishType: 1, //1：为发布供应数据类型，2：为发布求购数据类型
        enterprise: '', // 业务类型
        adcode: '', // 区域编码
        address: '', // 详细地址
        location: '', // 地理位置坐标（经纬度）
        description: '', // 描述信息
      },
      publishRules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        imgurl: [
          { required: true, message: '请上传类型图片', trigger: 'change' },
        ],
        amount: [{ required: true, message: '请输入挂单量', trigger: 'blur' }],
        orderRequirement: [
          { required: true, message: '请选择接单要求', trigger: 'change' },
        ],
        enterprise: [
          { required: true, message: '请选择业务类型', trigger: 'change' },
        ],
        adcode: [{ required: true, message: '请选择区域', trigger: 'change' }],
        linkman: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        location: [
          {
            pattern: /^-?\d+(\.\d+)?,-?\d+(\.\d+)?$/,
            message: '经纬度格式应为：经度,纬度，例如：130.21,30.29',
            trigger: 'blur',
          },
        ],
        phonenumber: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '请输入正确的手机号',
            trigger: 'blur',
          },
        ],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
      },
      typeList: [],
      typeList203: [],
      countList: ['<100斤', '100-1吨', '<10吨', '其他'],
      BasrUrl: process.env.VUE_APP_BASE_URL,
      windowWidth: window.innerWidth, // 存储当前窗口宽度
      dialogWidth: '35%', // 弹窗基础宽度（大屏默认值）
      labelWidth: '120px',
    };
  },
  created() {
    this.getTypeList();
    this.getTypeList203();
    this.getAreaData();
    this.getSupplyList();
  },
  mounted() {
    // 初始化弹窗宽度
    this.setDialogWidthByScreen();
    // 监听窗口大小变化，实时更新弹窗宽度
    window.addEventListener('resize', this.setDialogWidthByScreen);
  },
  // 组件销毁时移除监听，避免内存泄漏
  beforeDestroy() {
    window.removeEventListener('resize', this.setDialogWidthByScreen);
  },
  methods: {
    // 获取类型字段
    getTypeList203() {
      let parmrs = {
        typeCode: 203,
      };
      getCategories(parmrs).then((res) => {
        if (res.code === 200) {
          this.typeList203 = res.data;
        }
      });
    },
    // 新增：监听窗口宽度，动态设置弹窗宽度
    setDialogWidthByScreen() {
      this.windowWidth = window.innerWidth;
      // 768px及以下为移动端，弹窗宽度设为90%；以上为大屏，用默认百分比
      if (this.windowWidth <= 768) {
        this.dialogWidth = '90%'; // 移动端占满屏幕，操作更友好
        this.labelWidth = '80px';
      } else {
        this.dialogWidth = '35%'; // 大屏保持原有35%宽度
        this.labelWidth = '120px';
      }
    },
    // 获取类型字段
    getTypeList() {
      let parmrs = {
        typeCode: 202,
      };
      getCategories(parmrs).then((res) => {
        if (res.code === 200) {
          this.typeList = res.data;
        }
      });
    },
    // 获取行政区域
    getAreaData() {
      let code = 510000,
        recursion = 1;
      getAreaTreeData(code, recursion).then((res) => {
        this.locationOptions = res.data;
      });
    },
    // 获取供应列表
    getSupplyList() {
      this.loading = true;
      // 构造请求参数
      const params = {
        ...this.filterParams,
        adcode:
          Array.isArray(this.filterParams.adcode) &&
          this.filterParams.adcode.length > 0
            ? this.filterParams.adcode[this.filterParams.adcode.length - 1]
            : this.filterParams.adcode,
      };
      getPublish(params)
        .then((response) => {
          if (response.code === 200) {
            this.supplyList = response.data.records || [];
            this.totalCount = response.data.total || 0;
          } else {
            if (response.code === 401) {
              this.$message.error('用户未登录，无权查看此功能');
            } else {
              this.$message.error(response.message || '获取数据失败');
            }
            this.supplyList = [];
            this.totalCount = 0;
          }
        })
        .catch((error) => {
          this.$message.error('获取数据失败: ' + error.message);
          this.supplyList = [];
          this.totalCount = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 类型筛选
    handleTypeChange(item) {
      this.filterParams.type = item.value;
      this.filterParams.pageNum = 1;
      this.getSupplyList();
    },
    // 数量筛选（本地过滤）
    handleCountChange(count) {},
    // 排序切换
    handleSortChange(sortType) {
      this.filterParams.sort = sortType;
      this.getSupplyList();
    },
    // 分页
    handleSizeChange(val) {
      this.filterParams.pageSize = val;
      this.filterParams.pageNum = 1;
      this.getSupplyList();
    },
    handleCurrentChange(val) {
      this.filterParams.pageNum = val;
      this.getSupplyList();
    },
    // 详情弹窗
    openDetailDialog(item) {
      this.currentDetail = { ...item };
      this.detailDialogVisible = true;
    },
    // 发布弹窗
    openPublishDialog() {
      if (this.$store.state.ordinaryLoggedIn) {
        this.resetPublishForm();
        this.publishDialogVisible = true;
      } else {
        this.$confirm('用户未登录，是否前往登录', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$store.commit('login/changeLoginDialogVisible', true);
          })
          .catch(() => {});
      }
    },
    handleImageSuccess(value) {
      this.publishForm.imgurl = value.url;
      // 上传成功后，清除该字段的校验错误提示
      this.$nextTick(() => {
        this.$refs.publishFormRef?.clearValidate('imgurl');
      });
    },
    resetPublishForm() {
      this.publishForm = {
        title: '',
        type: '',
        imgurl: '',
        amount: '',
        unit: '吨',
        orderRequirement: '',
        linkman: '',
        phonenumber: '',
        publishType: 1, //1：为发布供应数据类型，2：为发布求购数据类型
        enterprise: '',
        adcode: '',
        address: '',
        location: '',
        description: '',
      };
      this.fileList = [];
      this.$refs.publishFormRef?.resetFields();
      this.publishDialogVisible = false;
    },
    // 提交发布(本地添加数据)
    submitPublish() {
      // 表单校验
      this.$refs.publishFormRef.validate((valid) => {
        if (!valid) {
          this.$message.warning('请完善必填项信息');
          return false;
        }

        const parmrs = {
          ...this.publishForm,
          adcode:
            Array.isArray(this.publishForm.adcode) &&
            this.publishForm.adcode.length > 0
              ? this.publishForm.adcode[this.publishForm.adcode.length - 1]
              : this.publishForm.adcode,
        };
        createPublish(parmrs).then((res) => {
          if (res.code === 200) {
            this.$message.success('已提交，待审核');
            this.getSupplyList();
            this.resetPublishForm();
          } else {
            this.$message.error('提交信息失败');
          }
        });
      });
    },
    getOrderRequirement(list, orderRequirement) {
      // 处理无效参数的情况
      if (!orderRequirement) return orderRequirement;

      // 查找匹配的接单要求标签
      const requirementItem = list.find(
        (item) => item.value == orderRequirement,
      );

      // 返回找到的标签或原始值
      return requirementItem
        ? requirementItem.label || requirementItem.name
        : orderRequirement || '暂无';
    },
    getRegionNameByAdcode(list, adcode) {
      // 统一处理入参：如果list是单个对象，转为数组（兼容根节点是对象的情况）
      const regionList = Array.isArray(list) ? list : [list];
      // 存储匹配到的名称路径
      const namePath = [];

      // 递归遍历树形结构
      function traverse(node) {
        // 找到匹配的adcode，记录名称并终止递归
        if (node.adcode === adcode) {
          namePath.push(node.name);
          return true;
        }

        // 存在子节点则递归遍历
        if (
          node.children &&
          Array.isArray(node.children) &&
          node.children.length
        ) {
          for (const child of node.children) {
            const found = traverse(child);
            // 子节点找到匹配项，当前节点名称入栈并终止遍历
            if (found) {
              namePath.push(node.name);
              return true;
            }
          }
        }

        // 未找到匹配项
        return false;
      }

      // 遍历根节点列表
      for (const rootNode of regionList) {
        if (traverse(rootNode)) {
          // 反转路径（递归是从子到父收集，反转后恢复父到子顺序）
          return namePath.reverse().join(' ');
        }
      }

      // 未匹配到返回空字符串
      return '';
    },
    // 下载模板
    async handleDownloadTemplate() {
      // TODO: 补充下载模板逻辑
      console.log('下载模板');
      try {
        const response = await axios.get(
          process.env.VUE_APP_API_BASE +
            '/resource/api/data/template/download/4',
          {
            responseType: 'blob',
            headers: {
              Authorization: `Bearer ${localStorage.getItem('ordinaryToken')}`,
            },
          },
        );
        if (response && response.status !== 200) {
          this.$message.error('下载失败');
          return;
        }
        // 替代方案：直接使用后端返回的文件名
        const fileName = response.headers['content-disposition']
          ? response.headers['content-disposition'].split('filename=')[1]
          : 'templete.xlsx';
        // 创建对象URL的替代方案
        const fileReader = new FileReader();
        fileReader.onload = (event) => {
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = event.target.result;
          a.download = '供需信息上报模版' + '.' + fileName.split('.')[1];
          // a.download = '价格数据上报模版.xlsx';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };
        fileReader.readAsDataURL(response.data);
      } catch (error) {
        console.error('下载失败:', error);
      }
    },
    // 导入数据
    handleImport() {
      this.$refs.fileInput.click();
    },
    normalizeImportResult(data = {}) {
      return {
        totalCount: Number(data.totalCount) || 0,
        successCount: Number(data.successCount) || 0,
        failCount: Number(data.failCount) || 0,
        message: data.message || '导入完成',
        errorDetails: Array.isArray(data.errorDetails) ? data.errorDetails : [],
      };
    },
    async handleImportFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      const fileName = file.name;
      const fileType = fileName
        .substring(fileName.lastIndexOf('.') + 1)
        .toLowerCase();
      if (fileType !== 'xlsx' && fileType !== 'xls') {
        this.$message.error('请上传 Excel 文件 (.xlsx 或 .xls)');
        this.$refs.fileInput.value = '';
        return;
      }

      const formData = new FormData();
      formData.append('file', file);

      try {
        this.loading = true;
        const res = await uploadTemplate(formData);
        if (res.code === 200) {
          this.importResult = this.normalizeImportResult(res.data);
          this.importResultVisible = true;
          if (this.importResult.successCount > 0) {
            this.getSupplyList();
          }
          if (this.importResult.failCount === 0) {
            this.$message.success('导入成功');
          } else if (this.importResult.successCount > 0) {
            this.$message.warning('部分数据导入失败，请查看详情');
          } else {
            this.$message.error('导入失败，请查看详情');
          }
        } else {
          this.$message.error(res.message || '导入失败');
        }
      } catch (error) {
        console.error('导入失败:', error);
        this.$message.error('导入失败，请稍后重试');
      } finally {
        this.loading = false;
        this.$refs.fileInput.value = '';
      }
    },
    async handleFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      // 简单校验文件类型
      const fileName = file.name;
      const fileType = fileName
        .substring(fileName.lastIndexOf('.') + 1)
        .toLowerCase();
      if (fileType !== 'xlsx' && fileType !== 'xls') {
        this.$message.error('请上传 Excel 文件 (.xlsx 或 .xls)');
        this.$refs.fileInput.value = ''; // 清空输入，允许重复上传同一文件
        return;
      }

      const formData = new FormData();
      formData.append('file', file);
      // 根据实际需求，可能需要添加其他参数，例如 publishType
      // formData.append('publishType', this.filterParams.publishType);

      try {
        this.loading = true;
        const res = await uploadTemplate(formData);
        if (res.code === 200) {
          this.$message.success('导入成功');
          this.getSupplyList(); // 刷新列表
        } else {
          this.$message.error(res.message || '导入失败');
        }
      } catch (error) {
        console.error('导入失败:', error);
        this.$message.error('导入失败，请稍后重试');
      } finally {
        this.loading = false;
        this.$refs.fileInput.value = ''; // 清空输入，允许重复上传同一文件
      }
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (max-width: 768px) {
  .smallScreen {
    display: block !important;
  }
  .bigScreen {
    display: none !important;
  }
  .supply-hall {
    width: 100% !important;
  }
  .supply-hall-banner {
    width: 100% !important;
    height: 120px !important;
  }

  .domTitle {
    font-size: 18px !important;
    font-weight: bold !important;
  }

  .el-card__body {
    padding: 10px !important;
  }
  .type-tag {
    height: 30px !important;
  }
  .filter-item {
    .filter-label {
      min-width: 40px !important;
      font-size: 12px !important;
    }
  }
  .filter-tags {
    .type-tag {
      font-size: 12px !important;
      margin: 5px 5px 0 0;
    }
  }
  .card-info {
    .card-title,
    .p,
    .card-info {
      font-size: 12px !important;
    }
  }
  /deep/.el-upload {
    width: 50% !important;
    height: 90px;
    line-height: 40px !important;
    .el-upload-dragger {
      width: 100% !important;
      height: 90px;
      .el-upload__text {
        font-size: 0 !important;
        margin: 0 !important;
        position: relative;
        line-height: 1 !important;
      }
      .el-icon-upload {
        margin: 0 !important;
        font-size: 50px !important;
      }
      .el-upload__tip {
        font-size: 12px !important;
        margin: 0 !important;
        position: absolute;
        top: 0;
        line-height: 1 !important;
      }
    }
  }
  /deep/.preview {
    width: 50% !important;
    height: 90px;
    line-height: 40px !important;
    .el-icon-delete {
      font-size: 20px !important;
    }
  }
  .box-card {
    height: auto !important;
    padding-bottom: 30px;
  }
  .filter-right {
    margin-top: 20px !important;
    .filter-right-btn {
      width: 100% !important;
      height: 40px !important;
    }
  }
  .card-list {
    display: block !important;
    grid-template-columns: unset !important;
    gap: unset !important;
    margin: 20px 0 30px 0;
  }
  .card-img {
    height: 85px !important;
  }
  .info-grep {
    display: block !important;
  }
  .detail-content {
    display: block !important;
  }
  .detail-img {
    width: 100% !important;
    height: 100% !important;
  }
  .detail-label {
    width: 70px !important;
  }
  .detail-item {
    margin-top: 15px !important;
  }
  .el-dialog__body {
    padding: 10px !important;
  }
  .el-form-item__label {
    width: 60px !important;
  }

  .recommend-badge {
    font-size: 11px !important;
    padding: 4px 12px 4px 10px !important;

    i {
      font-size: 12px !important;
    }
  }
}
/* 样式与之前版本一致，省略重复部分 */
.smallScreen {
  display: none;
}
/deep/.el-form-item__content {
  display: flex;
  align-items: center;
}
.supply-hall {
  box-sizing: border-box;

  .supply-hall-banner {
    height: 280px;
    width: 100%;
    position: relative;

    img {
      width: 100%;
      height: 100%;
    }

    .domTitle {
      font-weight: bold;
      font-size: 40px;
      color: #222222;
      position: absolute;
      left: 5%;
      top: 12%;
    }
  }
}

.filter-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 10px 0;
}

.filter-left {
  display: flex;
  flex: 8;
  align-items: center;
  flex-wrap: wrap;
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 10px 0;

  .type-tag,
  .count-tag {
    background: #f5f5f5;
    color: black;
    padding: 8px 16px;
    height: 40px;
    border-radius: 20px;
    border: 1px solid #e0e0e0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 16px;
  }
}

.choseTag {
  background-color: #1abe6b !important;
  border-color: #1abe6b !important;
  color: #ffffff !important;
}

.filter-label {
  min-width: 70px;
  height: 100%;
  font-size: 16px;
  color: #666;
}

.filter-control {
  width: 180px;
}

.filter-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.filter-right {
  flex: 2;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-direction: column;

  .filter-right-btn-secondary {
    background: #ffffff;
    border: 1px solid #dcdfe6;
    color: #606266;
    border-radius: 12px;
    width: 200px;
    height: 40px; // 修改：统一高度，或根据需求保留大屏特殊高度
    margin-left: 0 !important;

    &:hover {
      color: #409eff;
      border-color: #c6e2ff;
      background-color: #ecf5ff;
    }
  }

  .filter-right-btn {
    /* 保留原有样式，但移除绝对定位以适配 flex 布局 */
    /* position: absolute;  <-- 删除或覆盖此属性，因为现在使用 flex 布局 */
    width: 200px;
    height: 74px; // 修改：统一高度，或根据需求保留大屏特殊高度
    margin-left: 0 !important;
    background: #15ad61;
    border-radius: 12px 12px 12px 12px;
    border: 1px solid rgba(21, 173, 97, 0.1);
  }
}

.sort-bar {
  margin: 20px 0;
}

.sort-bar .active {
  color: #67c23a;
  font-weight: bold;
}

.card-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin: 20px 0 30px 0;
}

.supply-card {
  cursor: pointer;
  padding: 30px;
  background: #ffffff;
  box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &.recommended-card {
    border: 2px solid #1abe6b;
    background: linear-gradient(135deg, #ffffff 0%, #f0faf4 100%);
    box-shadow: 0px 8px 25px 0px rgba(26, 190, 107, 0.2);

    &:hover {
      box-shadow: 0px 12px 30px 0px rgba(26, 190, 107, 0.3);
      transform: translateY(-2px);
    }
  }
}

.supply-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.recommend-badge {
  position: absolute;
  top: 0;
  right: 0;
  background: linear-gradient(135deg, #1abe6b 0%, #2dd47a 100%);
  color: #ffffff;
  padding: 6px 16px 6px 12px;
  border-radius: 0 0 0 12px;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
  box-shadow: 0 2px 8px rgba(26, 190, 107, 0.4);
  z-index: 1;

  i {
    font-size: 14px;
    animation: starPulse 2s ease-in-out infinite;
  }

  @keyframes starPulse {
    0%,
    100% {
      transform: scale(1) rotate(0deg);
    }
    50% {
      transform: scale(1.15) rotate(5deg);
    }
  }
}

.card-img {
  width: 100%;
  height: 100px;
  object-fit: cover;
  border-radius: 4px;
}

.card-info {
  padding-left: 20px;
  height: 100px;

  .card-title {
    font-weight: 600;
    font-size: 24px;
    padding-left: 0;
    display: flex;
    align-items: center;
    color: #000000;
  }

  .card-info {
    font-weight: 600;
    font-size: 16px;
    padding-left: 0;
    color: #111111;
  }

  .info-grep {
    display: flex;
    flex: 1;
    justify-content: space-between;
  }
}

.card-info p {
  margin: 5px 0;
  font-size: 14px;
  line-height: 1.4;
}

.status-tag {
  margin-left: 10px;
}

.empty-state {
  padding: 40px 0;
  text-align: center;
}

.pagination {
  text-align: right;
  margin-bottom: 40px;
}

.detail-content {
  display: flex;
  gap: 24px;
}

.detail-img {
  width: 260px;
  height: 200px;
  object-fit: cover;
}

.detail-info {
  flex: 1;
}

.detail-info-title {
  margin-bottom: 10px;
}

.detail-item {
  display: flex;
  margin-bottom: 12px;
  line-height: 1.2;
}

.detail-label {
  font-weight: bold;
  width: 80px;
  flex-shrink: 0;
}

.detail-value {
  flex: 1;
}

.detail-info p {
  margin: 8px 0;
  font-size: 14px;
}

.publish-form {
  margin-top: 10px;
}

.upload-text {
  text-align: center;
  margin-top: 5px;
  font-size: 12px;
}

.unit-radio {
  margin-left: 10px;
}

.import-result-dialog {
  .import-result-summary {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    margin-bottom: 16px;
  }

  .summary-item {
    padding: 16px;
    background: #f5f7fa;
    border-radius: 8px;
    text-align: center;
  }

  .summary-item.success .summary-value {
    color: #67c23a;
  }

  .summary-item.fail .summary-value {
    color: #f56c6c;
  }

  .summary-label {
    display: block;
    color: #909399;
    font-size: 14px;
    margin-bottom: 6px;
  }

  .summary-value {
    font-size: 24px;
    font-weight: 600;
    color: #303133;
  }

  .import-result-message {
    margin-bottom: 16px;
    color: #606266;
    font-size: 14px;
  }

  .import-result-details {
    max-height: 420px;
    overflow-y: auto;
  }

  .detail-card {
    padding: 16px;
    margin-bottom: 12px;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    background: #fff;
  }

  .detail-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;
  }

  .detail-row-column {
    display: block;
    margin-bottom: 0;
  }

  .detail-label {
    width: 72px;
    flex-shrink: 0;
    color: #909399;
    line-height: 22px;
  }

  .detail-value {
    color: #303133;
    line-height: 22px;
    word-break: break-all;
  }

  .fail-text {
    color: #f56c6c;
  }

  .detail-data {
    margin: 8px 0 0;
    padding: 12px;
    white-space: pre-wrap;
    word-break: break-all;
    background: #f5f7fa;
    border-radius: 6px;
    color: #606266;
    font-size: 13px;
    line-height: 1.6;
  }
}
</style>
